import { useState } from 'react';
import { comiteVigilanciaData } from '@/mocks/nosotros-data';
import MemberModal from './MemberModal';

const memberImages: Record<string, string> = {
  'Luciano Augusto Díaz Límaco': 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20distinguished%20peruvian%20male%20musician%20and%20performer%20in%20his%20early%2050s%20warm%20genuine%20expression%20institutional%20atmosphere%20natural%20lighting%20authentic%20editorial%20portrait%20subtle%20charcoal%20tones%20leadership%20presence&width=600&height=750&seq=soniem-cv-presidente-2026&orientation=portrait',
  'José Francisco Meza Muñoz': 'https://readdy.ai/api/search-image?query=Authentic%20portrait%20of%20peruvian%20male%20musician%20in%20his%20mid%2040s%20warm%20natural%20expression%20professional%20artistic%20atmosphere%20genuine%20character%20soft%20studio%20lighting%20editorial%20portrait%20subtle%20warm%20earth%20tones&width=600&height=750&seq=soniem-cv-secretario-2026&orientation=portrait',
  'Rodolfo Barriga Montagne': 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20peruvian%20male%20musician%20in%20his%20late%2040s%20warm%20genuine%20expression%20institutional%20artistic%20setting%20natural%20lighting%20authentic%20character%20editorial%20portrait%20photography%20subtle%20burgundy%20undertones&width=600&height=750&seq=soniem-cv-vocal-2026&orientation=portrait',
};

export default function ComiteVigilancia() {
  const [selectedMember, setSelectedMember] = useState<{
    name: string;
    role: string;
    bio: string;
    imageUrl: string;
  } | null>(null);

  const { title, description, members } = comiteVigilanciaData;

  const openModal = (name: string, role: string, bio: string) => {
    setSelectedMember({
      name,
      role,
      bio,
      imageUrl: memberImages[name],
    });
  };

  return (
    <>
      <section className="py-16 md:py-24 bg-background-100">
        <div className="px-4 md:px-6 lg:px-10">
          <div className="max-w-5xl mx-auto">
            {/* Section Header */}
            <div className="mb-10 md:mb-14">
              <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
                Fiscalización
              </span>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-5">
                {title}
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-3xl leading-relaxed">
                {description}
              </p>
            </div>

            {/* Members Grid — same visual line as Consejo Directivo */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {members.map((member) => (
                <div
                  key={member.name}
                  className="group rounded-2xl bg-background-50 border border-secondary-200/60 overflow-hidden cursor-pointer hover:border-primary-200/60 transition-all duration-300"
                  onClick={() => openModal(member.name, member.role, member.bio)}
                >
                  {/* Member Photo */}
                  <div className="relative h-56 md:h-64 overflow-hidden">
                    <img
                      src={memberImages[member.name]}
                      alt={member.name}
                      className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent" />
                    <div className="absolute inset-0 flex items-end justify-center pb-5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                      <span className="inline-flex items-center gap-2 px-3.5 py-2 rounded-full bg-white/90 text-foreground-900 text-xs font-semibold whitespace-nowrap">
                        <i className="ri-eye-line" />
                        Ver semblanza
                      </span>
                    </div>
                  </div>
                  {/* Member Info */}
                  <div className="p-4 md:p-5 text-center">
                    <span className="inline-block px-2.5 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-2 whitespace-nowrap">
                      {member.role}
                    </span>
                    <h4 className="font-heading text-base font-bold text-foreground-900">
                      {member.name}
                    </h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      <MemberModal
        isOpen={selectedMember !== null}
        onClose={() => setSelectedMember(null)}
        name={selectedMember?.name || ''}
        role={selectedMember?.role || ''}
        bio={selectedMember?.bio || ''}
        imageUrl={selectedMember?.imageUrl || ''}
      />
    </>
  );
}